<a [shNavigationLink]="item.navigationLink" class="sh-link sh-icon-link">
  @if (item.icon && item.iconPosition === navigationItemIconPosition.Start) {
    <svg
      sh-icon
      [name]="item.icon"
      [size]="iconSize"
      aria-hidden="true"
      [ngClass]="iconClassNames"
    ></svg>
  }

  {{ item.label }}

  @if (item.badge) {
    <sh-badge [badge]="item.badge" [ngClass]="badgeClassNames"></sh-badge>
  }

  @if (item.icon && item.iconPosition !== navigationItemIconPosition.Start) {
    <svg
      sh-icon
      [name]="item.icon"
      [size]="iconSize"
      aria-hidden="true"
      [ngClass]="iconClassNames"
    ></svg>
  }
</a>
